//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { articleMenu } from '~/utils/article';

export default {
  name: 'ArticleContentDetails',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      articleMenu,
    };
  },
  computed: {
    nodata() {
      return !this.item || !this.item.content || this.item.length < 1;
    },
  },
};
